import script from "./HeaderCompo.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderCompo.vue?vue&type=script&setup=true&lang=js"

import "./HeaderCompo.vue?vue&type=style&index=0&id=acb903b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acb903b0"]])

export default __exports__